module.exports = __webpack_public_path__ + "open-sans-latin-300.80093af4e43c61663565.woff";


//////////////////
// WEBPACK FOOTER
// /Users/herbert/dev/awesum/awesum-web/~/typeface-open-sans/files/open-sans-latin-300.woff
// module id = ../../../../typeface-open-sans/files/open-sans-latin-300.woff
// module chunks = 1 3